<section class="px-4 bg-ayr-green-1000 text-ayr-white">
    <div class="py-9 lg:max-w-960 m-auto">
        <ul class="grid gap-12 justify-center lg:grid-cols-3">
            <li class="items-start grid grid-rows-[auto_1fr]">
                <p class="font-bold text-ayr-green-200 text-27 lg:text-47 text-center number-label">
                    38<span class="text-15 lg:text-21"> {{'citizens.information-banner.tonnes' | translate}}</span>
                </p>
                <p class="flex-grow text-center info-label font-bold">
                    {{'citizens.information-banner.avoided.first' | translate}}
                    {{'citizens.information-banner.avoided.second' | translate}}
                </p>
            </li>
            <li class="items-start grid grid-rows-[auto_1fr]">
                <p class="font-bold text-ayr-green-200 text-27 lg:text-47 text-center number-label">
                    130<span class="text-15 lg:text-21">k</span>
                </p>
                <p class="flex-grow text-center info-label font-bold">
                    {{'citizens.information-banner.green-trips.first' | translate}}
                    {{'citizens.information-banner.green-trips.second' | translate}}
                </p>
            </li>
            <li class="items-start grid grid-rows-[auto_1fr]">
                <p class="font-bold text-ayr-green-200 text-27 lg:text-47 text-center number-label">
                    372<span class="text-15 lg:text-21">k</span>
                </p>
                <p class="flex-grow text-center info-label font-bold">
                    {{'citizens.information-banner.ayr-credits.first' | translate}}
                    {{'citizens.information-banner.ayr-credits.second' | translate}}
                </p>
            </li>
        </ul>
    </div>
</section>